import { getAction, postAction } from '@/utils/http.js'//引入封装的get post方法

//联系我们
const contactUs = (params)=>getAction("/api/official/website/about_us/contact_us",params);

export {
    contactUs,
}